<template>
  <div style="display: none;"></div>
</template>

<script>
import { metadata } from '../config/metadata';

export default {
  name: 'MetaTags',
  props: {
    slug: {
      type: String,
      default: ''
    }
  },
  watch: {
    slug: {
      immediate: true,
      handler(slug) {
        this.updateMetaTags(slug);
      }
    }
  },
  methods: {
    updateMetaTags(slug) {
      const meta = metadata[slug] || metadata.default;
      
      // Update title
      document.title = meta.title;

      // Update meta tags
      this.updateTag('description', meta.description);
      
      // Update Open Graph tags
      this.updateTag('og:title', meta.title);
      this.updateTag('og:description', meta.description);
      this.updateTag('og:image', `${window.location.origin}${meta.image}`);
      this.updateTag('og:url', window.location.href);
      this.updateTag('og:type', meta.type);

      // Update Twitter Card tags
      this.updateTag('twitter:card', 'summary_large_image');
      this.updateTag('twitter:title', meta.title);
      this.updateTag('twitter:description', meta.description);
      this.updateTag('twitter:image', `${window.location.origin}${meta.image}`);
    },
    updateTag(name, content) {
      let element = document.querySelector(`meta[property="${name}"]`) || 
                   document.querySelector(`meta[name="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        if (name.startsWith('og:')) {
          element.setAttribute('property', name);
        } else {
          element.setAttribute('name', name);
        }
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    }
  }
};
</script> 